module.exports = {"data":{"site":{"siteMetadata":{"siteUrl":"https://www.focustaxsolutions.com.au"}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 93
// module chunks = 60335399758886 79611799117203